import { application } from "./application"

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import YoutubeConsentController from "./youtube_consent_controller"
application.register("youtube-consent", YoutubeConsentController)